import React, { Component } from 'react';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core styles
import 'ag-grid-community/styles/ag-theme-balham.css'; // Optional theme
import './ag-theme-ela.css';

const moment = require('moment');

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 1100;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  //suppressRowClickSelection: false,
  cellStyle: {
    borderRight: '1px solid #ccc', // Adds a light gray divider
  },
};

const jobNotesColumns = [
  {
    headerName: 'JobId',
    field: 'jobNum',
    cellRenderer: 'jobIdCellRenderer',
    width: 80,
  },
  {
    headerName: 'Note Date',
    field: 'createDateTime',
    cellRenderer: 'dateCellRenderer',
    width: 120,
  },
  { headerName: 'Reminder Created By', field: 'createdBy', width: 160 },
  {
    headerName: 'Reminder Date',
    field: 'reminderDate',
    cellRenderer: 'dateCellRenderer',
    width: 150,
  },
  {
    headerName: 'File',
    field: 'fileLocationS3',
    cellRenderer: 'notesCellRenderer',
    width: 120,
  },
  { headerName: 'Notes', field: 'notes', width: 1100 },
];

export class LateInvoicesTableJobNotes extends Component {
  static displayName = LateInvoicesTableJobNotes.name;

  constructor(props) {
    super(props);
    this.state = {
      columnWidths: jobNotesColumns.reduce((acc, col) => {
        acc[col.field] = col.width || DEFAULT_MIN_WIDTH_CELL; // Initialize widths
        return acc;
      }, {}),
      isResizing: -1,
    };
    this.previousSelection = [];
    // Bind methods
    this.onColumnResized = this.onColumnResized.bind(this);
    this.handleRowDoubleClick = this.handleRowDoubleClick.bind(this);
  }

  componentDidMount() {}

  handleRowDoubleClick(jobNoteData) {
    const jobNote = jobNoteData.data;

    this.props.handleNotesDoubleClick(jobNote);
  }

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      // Check if the width is not set in the column definition
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        // Ensure that you have access to the clientHeight property correctly
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });

      // Adding some padding or extra space if necessary
      maxHeight += 10; // Adjust this value based on your CSS and padding needs

      // Directly set the new header height
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns(false);
  };

  onDataLoaded = (newData) => {
    this.gridApi.setRowData(newData);
    this.autoSizeUnspecifiedColumns(true);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      // Update the state with new column width
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths }, () => {
        // Call adjustHeaderHeight after state update to ensure it uses the latest widths
        this.adjustHeaderHeight(this.gridApi);
      });
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: jobNotesColumns,
      rowData: this.props.jobNotes,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        setModal: this.setModal,
        state: this.state,
      },
      domLayout: 'autoHeight',
      animateRows: true,
      defaultColDef: defaultColDef,
      componentsw: {
        jobIdCellRenderer: JobIdCellRenderer,
        dateCellRenderer: DateCellRenderer,
        notesCellRenderer: NotesCellRenderer,
      },
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.handleRowDoubleClick,
    };
    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '600px',
        }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}

class JobIdCellRenderer extends React.Component {
  render() {
    const { context } = this.props;
    const selectedJobNum = context.state.selectedJobNum;
    return <span>{selectedJobNum}</span>;
  }
}

class DateCellRenderer extends React.Component {
  render() {
    const { value } = this.props;
    return <span>{value ? moment(value).format('MM/DD/YYYY') : ''}</span>;
  }
}
class NotesCellRenderer extends React.Component {
  handleClick = (e) => {
    e.stopPropagation();
    const { data, context } = this.props;
    context.componentParent.props.viewS3File(data);
  };

  render() {
    const { value } = this.props;

    var html = value && (
      <span
        onClick={this.handleClick}
        style={{
          cursor: 'pointer',
          color: 'blue',
          textDecoration: 'underline',
        }}
      >
        Click To View
      </span>
    );

    return html;
  }
}
